import { render, staticRenderFns } from "./pantallasVacias.vue?vue&type=template&id=06f917b4&scoped=true&"
import script from "./pantallasVacias.vue?vue&type=script&lang=js&"
export * from "./pantallasVacias.vue?vue&type=script&lang=js&"
import style0 from "./pantallasVacias.vue?vue&type=style&index=0&id=06f917b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f917b4",
  null
  
)

export default component.exports